<template>
  <div class="entry-main-wrapper">
    <DataLoader :is_on="fetching" />
    <div class="entry-wrapper">
      <div class="entry-header">
        <div class="entry-header-left">
          <div class="entry-icon personal-user-edit">
            <img :src="avatar_link" />
          </div>
          <div class="entry-title">{{naziv_forme}}</div>
        </div>
        <div class="entry-header-right">
          <a @click="goBack()" class="entry-exit"
            ><img src="@/assets/img/entry_form_close.svg"
          /></a>
        </div>
      </div>
      <!-- end new person header -->
      <div class="main-entry-form-wrapper">
        <!-- *** VRSTA **** -->

        <TeamMember
          :invalid_elements="invalid_elements_fiz"
          ref="fizickaOsoba"
          @finished="finishSetup"
        />
        
        <InvalidElementsList v-if="error_list.length != 0" :error_list="error_list"/>
        <!-- *** KREIRAJ BUTTON **** -->
        <div class="button-create-wrapper" @click="!is_waiting_on_insert ? edit_create_fizicka() : ''">
          <div :style="is_waiting_on_insert ? 'background-color: gray' : 'background-color: #2a23a0'" class="button-default button-create">{{naziv_gumb}}</div>
        </div>
      </div>
    </div>
    <!-- end new case wrapper -->
  </div>
  <!-- end new case main wrapper -->
</template>
	
	<script>
import formInput from "@/components/formElements/formInput.vue";
import formTextarea from "@/components/formElements/formTextarea.vue";
import formDropDown from "@/components/formElements/formDropDown.vue";
import formAutocomplete from "@/components/formElements/formInputAutocomplete.vue";
import TeamMember from "@/components/personComponents/TeamMember.vue";
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import osobe from "@/apiCallers/promise_handler_db/osobe_pr";
import institutions from "@/apiCallers/promise_handler_db/institucije";
import auth from "@/services/auth";
import DataLoader from '@/components/generalComponents/DataLoader'
import $ from "jquery";
import gsap from "gsap";

export default {
  data() {
    return {
      naziv_forme: 'Uredi podatke profila',
      naziv_gumb: 'Pohrani izmjene',
      avatar_link : "",

      is_waiting_on_insert:false,
      is_edit: false,
      error_list: [],
      invalid_elements_fiz: {
        ime: false,
        prezime: false,
        izvor: false,
        custom_ime_izvora: false,
      },

      edit_type: {},
      trenutna_vrsta: 1,

      fizicke: [],
      tim: [],
      pravne: [],
      institucije: [],
      fetching: true,
    };
  },
 
  methods: {
    finishSetup(av_link){
      this.fetching = false;
      this.avatar_link = av_link
    },
    goBack() {
      this.$router.go(-1);
    },
    validate_fizicka(){
      this.error_list = [];
      this.invalid_elements_fiz = {
        ime: false,
        prezime: false,
        izvor: false,
        custom_ime_izvora: false,
      };
      let data = this.$refs.fizickaOsoba.$data.fizicka;
      if (data.ime.value == "") {
        this.error_list.push("Potrebno je unijeti ime osobe");
        this.invalid_elements_fiz.ime = true;
      }
      if (data.prezime.value == "") {
        this.error_list.push("Potrebno je unijeti prezime osobe");
        this.invalid_elements_fiz.prezime = true;
      }

    },
    get_avatar(){
      return this.$store.state.avatar_image
       
    },

    edit_create_fizicka() {
      let data = this.$refs.fizickaOsoba.$data.fizicka;
      this.validate_fizicka();
      let fizicka = {
        ime: data.ime.value,
        prezime: data.prezime.value,
        OIB: data.oib.value != "" ? data.oib.value : null,
        email: data.email_list.length != 0 ? data.email_list.values : null,
        brojevi_telefona:
          data.tel_br_list.length != 0 ? data.tel_br_list.values : null,
        adrese:
          data.adrese_list.lista_adresa.length != 0
            ? data.adrese_list.lista_adresa
            : null,
        web_stranice: data.web_list.length != 0 ? data.web_list.values : null,
        radno_vrijeme:
          data.radno_vrijeme.value != "" ? data.radno_vrijeme.value : null,
        // rodjendan: data.rodjendan != "" ? new Date(data.rodjendan) : undefined,
        team_filled: this.$store.state.logged_in_user.uid,
        opis : data.opis.value
      };
      if (this.error_list.length == 0) {
        this.fetching = true;
        this.is_waiting_on_insert = true;
        console.log(fizicka)
          osobe
            .editOdvjetnik(this.$store.state.logged_in_user.uid,fizicka)
            .then((response) => {
              this.fetching = false;
              this.is_waiting_on_insert = false;
              this.$router.push('/osobe/law/'+this.$store.state.logged_in_user.uid);
            });
      }
    },

  },

  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
        this.is_edit = true;

        


  },
  watch:{
     "$store.state.avatar_image": {
      handler: function (avatar_image) {
        console.log("change in val", avatar_image)
        this.avatar_link = avatar_image
      },
     }
  },

  components: {
    "form-input": formInput,
    "form-textarea": formTextarea,
    "form-drop-down": formDropDown,
    "form-autocomplete": formAutocomplete,
    TeamMember,
    InvalidElementsList,
    DataLoader
  },

  mounted() {
    document.body.classList.add("new-entry");
    //zašto je to tu?
    //close anim
    $(".entry-exit").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
    osobe.getAllIndustries().then((resp) => {
      this.industrija = resp.data;
      console.log(this.industrija);
    });
    osobe.getAllStrankeProtustranke().then((resp) => {
      //console.log(resp.data);
      // this.industrija = resp.data
    });
    institutions.getAllInstitucijeShort().then((resp) => {
      this.institucije = resp.data;
    });
    osobe.getAllFizLeg().then((resp) => {
      this.pravne = resp.data.all_osobe.filter((item) => item.is_fiz == false);
      this.fizicke = resp.data.all_osobe.filter((item) => item.is_fiz == true);
      this.tim = resp.data.all_pravnici;
      console.log(resp.data);
    });
  },
  updated() {},
  destroyed() {
    document.body.classList.remove("new-entry");
    $(".entry-exit").off();
  },
};
</script>
	